import { BrowserProvider } from "ethers";
import { api } from "@/lib/api";

export const getMyTokens = (owner) => api.get(`/my-tokens/${owner}`).then((r) => r.data);

const trackMessage = (action, address, owner, timestamp) =>
  `FSC Hub: ${action} token ${address.toLowerCase()} in My Tokens for ${owner.toLowerCase()} at ${timestamp}`;

/** Tracks/untracks a token for the connected wallet; the wallet signs a short message to prove ownership. */
export async function setTokenTracked({ eip1193, owner, address, action }) {
  const timestamp = Math.floor(Date.now() / 1000);
  const signer = await new BrowserProvider(eip1193).getSigner();
  const signature = await signer.signMessage(trackMessage(action, address, owner, timestamp));
  return api.post("/my-tokens/track", { owner, address, action, timestamp, signature }).then((r) => r.data);
}
